var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: _vm.title,
        width: "1200px",
        height: "545px",
        top: "10vh",
      },
      on: { success: _vm.successFn },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "ele-tabs-wrap" },
        [
          _c(
            "el-tabs",
            {
              on: {
                "tab-click": function ($event) {
                  return _vm.getClassList()
                },
              },
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            },
            _vm._l(_vm.types, function (item) {
              return _c(
                "el-tab-pane",
                { key: item, attrs: { name: String(item) } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(" " + _vm._s(_vm.tabs[item].name) + " "),
                  ]),
                ]
              )
            }),
            1
          ),
          _c("div", { staticClass: "ss-material-picture" }, [
            _c(
              "div",
              { staticClass: "left-wrap" },
              [
                _vm.type === "0"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "m-r-20",
                        nativeOn: {
                          click: function ($event) {
                            return _vm.openUpImg.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("上传图片")]
                    )
                  : _vm._e(),
                _vm.type === "1"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "m-r-20",
                        nativeOn: {
                          click: function ($event) {
                            return _vm.openUpVideo.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("上传音频")]
                    )
                  : _vm._e(),
                _vm.type === "2"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "m-r-20",
                        nativeOn: {
                          click: function ($event) {
                            return _vm.uploadVideo.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("上传视频")]
                    )
                  : _vm._e(),
                _vm.type === "4"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "m-r-20",
                        nativeOn: {
                          click: function ($event) {
                            return _vm.openUpFile.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("上传文档")]
                    )
                  : _vm._e(),
                _c(
                  "span",
                  {
                    staticClass: "ss-material-button",
                    on: {
                      click: function ($event) {
                        return _vm.gotoMaterial()
                      },
                    },
                  },
                  [_vm._v("前往素材中心")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right-wrap" },
              [
                _vm.type === "0" || _vm.type === "2"
                  ? _c("i", {
                      staticClass: "el-icon-s-fold",
                      class: { active: _vm.listType === "list" },
                      on: {
                        click: function ($event) {
                          return _vm.changeListType("list")
                        },
                      },
                    })
                  : _vm._e(),
                _vm.type === "0" || _vm.type === "2"
                  ? _c("i", {
                      staticClass: "el-icon-menu",
                      class: { active: _vm.listType === "card" },
                      on: {
                        click: function ($event) {
                          return _vm.changeListType("card")
                        },
                      },
                    })
                  : _vm._e(),
                _c("m-select", {
                  staticStyle: { "margin-right": "5px" },
                  attrs: {
                    "dict-key": "COMMODITY_SORT",
                    placeholder: "请选择排序方式",
                    size: "small",
                  },
                  on: { change: _vm.handleSlortChage },
                  model: {
                    value: _vm.slort,
                    callback: function ($$v) {
                      _vm.slort = $$v
                    },
                    expression: "slort",
                  },
                }),
                _c("el-input", {
                  attrs: {
                    placeholder:
                      ["图片", "音频", "视频", "", "文档"][_vm.type] + "名称",
                    size: "small",
                    "prefix-icon": "el-icon-search",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getList()
                    },
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "search",
                  },
                }),
                _c("el-button", {
                  staticClass: "m-l-10",
                  attrs: { icon: "el-icon-refresh", type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.init()
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "ss-material-main" }, [
            _c("div", { staticClass: "ss-material-main-left" }, [
              _c(
                "div",
                { staticClass: "ss-material-main-tree" },
                [
                  _c("AppTree", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "appTreeForImage",
                    staticStyle: { width: "200px" },
                    attrs: {
                      "auto-expand-parent": true,
                      loading: _vm.treeLoading,
                      nobtn: true,
                    },
                    on: { "node-click": _vm.treeClick },
                    model: {
                      value: _vm.classlist,
                      callback: function ($$v) {
                        _vm.classlist = $$v
                      },
                      expression: "classlist",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "ss-material-main-right",
              },
              [
                _c("div", { staticClass: "content-wrap" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.listType === "card",
                          expression: "listType === 'card'",
                        },
                      ],
                      staticClass: "card-pattern-list-wrap",
                    },
                    [
                      Boolean(
                        _vm.multiple &&
                          ["1", "2"].includes(_vm.type) &&
                          _vm.optionType === "add"
                      )
                        ? _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [_vm._v("全选 ")]
                          )
                        : _vm._e(),
                      Boolean(
                        _vm.multiple &&
                          ["1", "2"].includes(_vm.type) &&
                          _vm.optionType === "add"
                      )
                        ? _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleSelectionChange },
                              model: {
                                value: _vm.multipleSelection,
                                callback: function ($$v) {
                                  _vm.multipleSelection = $$v
                                },
                                expression: "multipleSelection",
                              },
                            },
                            _vm._l(_vm.tableData, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.materialId,
                                  staticClass: "picture-card",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "content" },
                                    [
                                      _vm.type === "0"
                                        ? _c("ImagePreviewer", {
                                            staticClass: "el-image",
                                            attrs: {
                                              src: item.materialUrl,
                                              fit: "contain",
                                              "preview-src-list": _vm.srcList,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.type === "2"
                                        ? _c("img", {
                                            attrs: {
                                              src: item.materialFrameUrl,
                                              alt: item.materialName,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.playVideo(item)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.type === "0"
                                        ? _c(
                                            "div",
                                            { staticClass: "resolution" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("filterDes")(
                                                      item.materialDes
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "resolution" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("filterTime")(
                                                      item.materialDes
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "detail" }, [
                                    _c(
                                      "div",
                                      { staticClass: "title-wrap" },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: {
                                              label: item,
                                              disabled: _vm.disabledFn(item),
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "title",
                                                attrs: {
                                                  title: item.materialName,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.materialName) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "common-row" }, [
                                      _vm._v(_vm._s(item.createTime)),
                                    ]),
                                    _c("div", { staticClass: "common-row" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("filterSize")(
                                              item.materialSize
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.radio,
                                callback: function ($$v) {
                                  _vm.radio = $$v
                                },
                                expression: "radio",
                              },
                            },
                            _vm._l(_vm.tableData, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.materialId,
                                  staticClass: "picture-card",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "content" },
                                    [
                                      _vm.type === "0"
                                        ? _c("ImagePreviewer", {
                                            staticClass: "el-image",
                                            attrs: {
                                              src: item.materialUrl,
                                              fit: "contain",
                                              "preview-src-list": _vm.srcList,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.type === "2"
                                        ? _c("img", {
                                            attrs: {
                                              src: item.materialFrameUrl,
                                              alt: item.materialName,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.playVideo(item)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.type === "0"
                                        ? _c(
                                            "div",
                                            { staticClass: "resolution" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("filterDes")(
                                                      item.materialDes
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "resolution" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("filterTime")(
                                                      item.materialDes
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "detail" }, [
                                    _c(
                                      "div",
                                      { staticClass: "title-wrap" },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              label: item,
                                              disabled: _vm.disabledFn(item),
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "title",
                                                attrs: {
                                                  title: item.materialName,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.materialName) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "common-row" }, [
                                      _vm._v(_vm._s(item.createTime)),
                                    ]),
                                    _c("div", { staticClass: "common-row" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("filterSize")(
                                              item.materialSize
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.listType === "list",
                          expression: "listType === 'list'",
                        },
                      ],
                      staticClass: "table-wrap",
                    },
                    [
                      Boolean(
                        _vm.multiple &&
                          ["1", "2"].includes(_vm.type) &&
                          _vm.optionType === "add"
                      )
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "header-wrap",
                                staticStyle: { width: "100%" },
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    ref: "multipleTable",
                                    staticStyle: { width: "950px" },
                                    attrs: {
                                      height: "360",
                                      data: _vm.tableData,
                                      "tooltip-effect": "dark",
                                      "row-key": _vm.rowKey,
                                      "header-cell-style": {
                                        background: "#f5f5f5",
                                        padding: "0",
                                      },
                                    },
                                    on: {
                                      "selection-change":
                                        _vm.handleSelectionChange,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        type: "selection",
                                        "reserve-selection": true,
                                        selectable: _vm.selectable,
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "550",
                                        prop: "materialName",
                                        label: [
                                          "图片",
                                          "音频",
                                          "视频",
                                          "",
                                          "文档",
                                        ][_vm.type],
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ row, $index }) {
                                              return [
                                                _vm.type == "0"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "fl fl_ai_c",
                                                      },
                                                      [
                                                        _c("ImagePreviewer", {
                                                          staticStyle: {
                                                            "max-width":
                                                              "100px",
                                                            height: "100px",
                                                            "min-width":
                                                              "100px",
                                                          },
                                                          attrs: {
                                                            src: row.materialUrl,
                                                            fit: "contain",
                                                            "preview-src-list":
                                                              _vm.srcList,
                                                            "preview-index":
                                                              $index,
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "m-l-20",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "m-picture-title",
                                                                attrs: {
                                                                  title:
                                                                    row.materialName,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      row.materialName
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "m-picture-property",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "filterDes"
                                                                      )(
                                                                        row.materialDes
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.type === "1"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "fl fl_ai_c",
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          staticStyle: {
                                                            width: "60px",
                                                            height: "60px",
                                                            "font-size": "60px",
                                                          },
                                                          attrs: {
                                                            "class-name":
                                                              "size-icon",
                                                            "icon-class":
                                                              "audio",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.play(
                                                                row.materialUrl
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "m-l-10 text_hidden",
                                                            attrs: {
                                                              title:
                                                                row.materialName,
                                                            },
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.materialName
                                                                )
                                                              ),
                                                            ]),
                                                            [
                                                              "Transcoding",
                                                              "Uploading",
                                                              "Checking",
                                                            ].includes(
                                                              row.status
                                                            ) &&
                                                            row.transcodeProgress !==
                                                              100
                                                              ? _c(
                                                                  "div",
                                                                  [
                                                                    _vm._v(
                                                                      " 视频解码中，解码完成" +
                                                                        _vm._s(
                                                                          row.transcodeProgress
                                                                        ) +
                                                                        "%，请解码成功再加入课程 "
                                                                    ),
                                                                    _c(
                                                                      "el-button",
                                                                      {
                                                                        attrs: {
                                                                          size: "mini",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleRefreshItem(
                                                                                row
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "刷新进度"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.type === "2"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "fl fl_ai_c",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "videoImg",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: row.materialFrameUrl,
                                                                alt: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.playVideo(
                                                                      row
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "m-l-10 text_hidden",
                                                            attrs: {
                                                              title:
                                                                row.materialName,
                                                            },
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.materialName
                                                                )
                                                              ),
                                                            ]),
                                                            [
                                                              "Transcoding",
                                                              "Uploading",
                                                              "Checking",
                                                            ].includes(
                                                              row.status
                                                            ) &&
                                                            row.transcodeProgress !==
                                                              100
                                                              ? _c(
                                                                  "div",
                                                                  [
                                                                    _vm._v(
                                                                      " 视频解码中，解码完成" +
                                                                        _vm._s(
                                                                          row.transcodeProgress
                                                                        ) +
                                                                        "%，请解码成功再加入课程 "
                                                                    ),
                                                                    _c(
                                                                      "el-button",
                                                                      {
                                                                        attrs: {
                                                                          size: "mini",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.handleRefreshItem(
                                                                                row
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "刷新进度"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.type === "4"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "fl fl_ai_c",
                                                      },
                                                      [
                                                        [
                                                          "xls",
                                                          "xlsx",
                                                          "cvs",
                                                          "xlsm",
                                                        ].includes(
                                                          row.materialName
                                                            .split(".")
                                                            .pop()
                                                            .toLowerCase()
                                                        )
                                                          ? _c("img", {
                                                              staticClass:
                                                                "size-icon",
                                                              attrs: {
                                                                src: require("@/assets/image/pdf.png"),
                                                                fit: "contain",
                                                              },
                                                            })
                                                          : [
                                                              "ppt",
                                                              "pptx",
                                                            ].includes(
                                                              row.materialName
                                                                .split(".")
                                                                .pop()
                                                                .toLowerCase()
                                                            )
                                                          ? _c("img", {
                                                              staticClass:
                                                                "size-icon",
                                                              attrs: {
                                                                src: require("@/assets/image/ppt.png"),
                                                                fit: "contain",
                                                              },
                                                            })
                                                          : [
                                                              "doc",
                                                              "docx",
                                                              "pdf",
                                                            ].includes(
                                                              row.materialName
                                                                .split(".")
                                                                .pop()
                                                                .toLowerCase()
                                                            )
                                                          ? _c("img", {
                                                              staticClass:
                                                                "size-icon",
                                                              attrs: {
                                                                src: require("@/assets/image/ppt2.png"),
                                                                fit: "contain",
                                                              },
                                                            })
                                                          : ["word"].includes(
                                                              row.materialName
                                                                .split(".")
                                                                .pop()
                                                                .toLowerCase()
                                                            )
                                                          ? _c("img", {
                                                              staticClass:
                                                                "size-icon",
                                                              attrs: {
                                                                src: require("@/assets/image/word.png"),
                                                                fit: "contain",
                                                              },
                                                            })
                                                          : ["txt"].includes(
                                                              row.materialName
                                                                .split(".")
                                                                .pop()
                                                                .toLowerCase()
                                                            )
                                                          ? _c("img", {
                                                              staticClass:
                                                                "size-icon",
                                                              attrs: {
                                                                src: require("@/assets/image/txt.png"),
                                                                fit: "contain",
                                                              },
                                                            })
                                                          : _c("img", {
                                                              staticClass:
                                                                "size-icon",
                                                              attrs: {
                                                                src: require("@/assets/image/weizhigeshi.png"),
                                                                fit: "contain",
                                                              },
                                                            }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "m-l-10",
                                                            attrs: {
                                                              title:
                                                                row.materialName,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.materialName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2109403304
                                      ),
                                    }),
                                    _vm.type === "1" || _vm.type === "2"
                                      ? _c("el-table-column", {
                                          attrs: {
                                            prop: "materialDes",
                                            label: "时长",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ row }) {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f("filterTime")(
                                                            row.materialDes
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            815186154
                                          ),
                                        })
                                      : _vm._e(),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "materialSize",
                                        label: "大小",
                                        "show-overflow-tooltip": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ row }) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("filterSize")(
                                                        row.materialSize
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2962060749
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "160",
                                        prop: "createTime",
                                        label: "上传时间",
                                        "show-overflow-tooltip": "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "el-radio-group",
                              {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.radio,
                                  callback: function ($$v) {
                                    _vm.radio = $$v
                                  },
                                  expression: "radio",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "header-wrap",
                                    staticStyle: { width: "100%" },
                                  },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        ref: "multipleTable",
                                        staticStyle: { width: "950px" },
                                        attrs: {
                                          height: "360",
                                          data: _vm.tableData,
                                          "tooltip-effect": "dark",
                                          "row-key": _vm.rowKey,
                                          "header-cell-style": {
                                            background: "#f5f5f5",
                                            padding: "0",
                                          },
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: { width: "50" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      staticStyle: {
                                                        width: "14px",
                                                        overflow: "hidden",
                                                      },
                                                      attrs: {
                                                        label: row,
                                                        disabled:
                                                          _vm.disabledFn(row) ||
                                                          _vm.selectableRidio(
                                                            row
                                                          ),
                                                      },
                                                    },
                                                    [_c("span")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            width: "550",
                                            prop: "materialName",
                                            label: [
                                              "图片",
                                              "音频",
                                              "视频",
                                              "",
                                              "文档",
                                            ][_vm.type],
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function ({ row, $index }) {
                                                return [
                                                  _vm.type == "0"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fl fl_ai_c",
                                                        },
                                                        [
                                                          _c("ImagePreviewer", {
                                                            staticStyle: {
                                                              "max-width":
                                                                "100px",
                                                              height: "100px",
                                                              "min-width":
                                                                "100px",
                                                            },
                                                            attrs: {
                                                              src: row.materialUrl,
                                                              fit: "contain",
                                                              "preview-src-list":
                                                                _vm.srcList,
                                                              "preview-index":
                                                                $index,
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "m-l-20",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-picture-title",
                                                                  attrs: {
                                                                    title:
                                                                      row.materialName,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        row.materialName
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "m-picture-property",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "filterDes"
                                                                        )(
                                                                          row.materialDes
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.type === "1"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fl fl_ai_c",
                                                        },
                                                        [
                                                          _c("svg-icon", {
                                                            staticStyle: {
                                                              width: "60px",
                                                              height: "60px",
                                                              "font-size":
                                                                "60px",
                                                            },
                                                            attrs: {
                                                              "class-name":
                                                                "size-icon",
                                                              "icon-class":
                                                                "audio",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.play(
                                                                  row.materialUrl
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "m-l-10 text_hidden",
                                                              attrs: {
                                                                title:
                                                                  row.materialName,
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.materialName
                                                                  )
                                                                ),
                                                              ]),
                                                              [
                                                                "Transcoding",
                                                                "Uploading",
                                                                "Checking",
                                                              ].includes(
                                                                row.status
                                                              ) &&
                                                              row.transcodeProgress !==
                                                                100
                                                                ? _c(
                                                                    "div",
                                                                    [
                                                                      _vm._v(
                                                                        " 视频解码中，解码完成" +
                                                                          _vm._s(
                                                                            row.transcodeProgress
                                                                          ) +
                                                                          "%，请解码成功再加入课程 "
                                                                      ),
                                                                      _c(
                                                                        "el-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              size: "mini",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleRefreshItem(
                                                                                  row
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "刷新进度"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.type === "2"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fl fl_ai_c",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "videoImg",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: row.materialFrameUrl,
                                                                  alt: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.playVideo(
                                                                        row
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "m-l-10 text_hidden",
                                                              attrs: {
                                                                title:
                                                                  row.materialName,
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    row.materialName
                                                                  )
                                                                ),
                                                              ]),
                                                              [
                                                                "Transcoding",
                                                                "Uploading",
                                                                "Checking",
                                                              ].includes(
                                                                row.status
                                                              ) &&
                                                              row.transcodeProgress !==
                                                                100
                                                                ? _c(
                                                                    "div",
                                                                    [
                                                                      _vm._v(
                                                                        " 视频解码中，解码完成" +
                                                                          _vm._s(
                                                                            row.transcodeProgress
                                                                          ) +
                                                                          "%，请解码成功再加入课程 "
                                                                      ),
                                                                      _c(
                                                                        "el-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              size: "mini",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleRefreshItem(
                                                                                  row
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "刷新进度"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.type === "4"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fl fl_ai_c",
                                                        },
                                                        [
                                                          [
                                                            "xls",
                                                            "xlsx",
                                                            "cvs",
                                                            "xlsm",
                                                          ].includes(
                                                            row.materialName
                                                              .split(".")
                                                              .pop()
                                                              .toLowerCase()
                                                          )
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "size-icon",
                                                                attrs: {
                                                                  src: require("@/assets/image/pdf.png"),
                                                                  fit: "contain",
                                                                },
                                                              })
                                                            : [
                                                                "ppt",
                                                                "pptx",
                                                              ].includes(
                                                                row.materialName
                                                                  .split(".")
                                                                  .pop()
                                                                  .toLowerCase()
                                                              )
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "size-icon",
                                                                attrs: {
                                                                  src: require("@/assets/image/ppt.png"),
                                                                  fit: "contain",
                                                                },
                                                              })
                                                            : [
                                                                "doc",
                                                                "docx",
                                                                "pdf",
                                                              ].includes(
                                                                row.materialName
                                                                  .split(".")
                                                                  .pop()
                                                                  .toLowerCase()
                                                              )
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "size-icon",
                                                                attrs: {
                                                                  src: require("@/assets/image/ppt2.png"),
                                                                  fit: "contain",
                                                                },
                                                              })
                                                            : ["word"].includes(
                                                                row.materialName
                                                                  .split(".")
                                                                  .pop()
                                                                  .toLowerCase()
                                                              )
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "size-icon",
                                                                attrs: {
                                                                  src: require("@/assets/image/word.png"),
                                                                  fit: "contain",
                                                                },
                                                              })
                                                            : ["txt"].includes(
                                                                row.materialName
                                                                  .split(".")
                                                                  .pop()
                                                                  .toLowerCase()
                                                              )
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "size-icon",
                                                                attrs: {
                                                                  src: require("@/assets/image/txt.png"),
                                                                  fit: "contain",
                                                                },
                                                              })
                                                            : _c("img", {
                                                                staticClass:
                                                                  "size-icon",
                                                                attrs: {
                                                                  src: require("@/assets/image/weizhigeshi.png"),
                                                                  fit: "contain",
                                                                },
                                                              }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "m-l-10",
                                                              attrs: {
                                                                title:
                                                                  row.materialName,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  row.materialName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ]),
                                        }),
                                        _vm.type === "1" || _vm.type === "2"
                                          ? _c("el-table-column", {
                                              attrs: {
                                                prop: "materialDes",
                                                label: "时长",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ row }) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "filterTime"
                                                              )(row.materialDes)
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                815186154
                                              ),
                                            })
                                          : _vm._e(),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "materialSize",
                                            label: "大小",
                                            "show-overflow-tooltip": "",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function ({ row }) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("filterSize")(
                                                          row.materialSize
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            width: "160",
                                            prop: "createTime",
                                            label: "上传时间",
                                            "show-overflow-tooltip": "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "pagination-wrap" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.total,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }